module.exports = __webpack_public_path__ + "img/2.79d0a829.png";